import { StandardButton } from '@components/buttons/StandardButton';
import { LinearProgress, TableBody, TableCell, TableRow } from '@mui/material';

interface SearchTableBodyProps {
    numCols: number;
    rows: { id: string; value: string }[];
    actions: { color: 'primary' | 'error'; text: string; onClick: (id: string) => void }[];
    emptyListText: string;
    loading: boolean;
}

export const SearchTableBodyV2 = ({ numCols, rows, actions, emptyListText, loading }: SearchTableBodyProps) => {
    return (
        <TableBody>
            {loading ? (
                <TableRow sx={{ width: '100%' }}>
                    <TableCell colSpan={numCols} sx={{ width: '100%' }}>
                        <LinearProgress />
                    </TableCell>
                </TableRow>
            ) : rows.length ? (
                rows.map((item, index) => (
                    <TableRow key={index}>
                        <TableCell key={`${index}-${item.id}`} style={{ borderColor: 'rgba(224, 224, 224, 1)' }}>
                            {item.value}
                        </TableCell>

                        <TableCell
                            key={`${index}-action`}
                            style={{
                                borderColor: 'rgba(224, 224, 224, 1)',
                                display: 'flex',
                                justifyContent: 'flex-end',
                            }}>
                            {actions.map((action, actionIdx) => (
                                <StandardButton
                                    key={`${index}-action-${actionIdx}`}
                                    {...action}
                                    onClick={() => action.onClick(item.id)}
                                />
                            ))}
                        </TableCell>
                    </TableRow>
                ))
            ) : (
                <TableRow>
                    <TableCell>{emptyListText}</TableCell>
                </TableRow>
            )}
        </TableBody>
    );
};
